import { render, staticRenderFns } from "./PostData.vue?vue&type=template&id=359d988a&"
import script from "./PostData.vue?vue&type=script&lang=js&"
export * from "./PostData.vue?vue&type=script&lang=js&"
import style0 from "./PostData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports